import { legalLabels } from '@procumi/shared';

/**
 * Țara firmei curente, pentru ecranele care au nevoie doar de ea (numele
 * datelor legale, verificarea CUI-ului). O singură firmă pe sesiune, deci o
 * ține App la fiecare desenare, în loc să o trecem prin toate ecranele.
 */
let country = 'RO';

export function setMarketCountry(c: string): void {
  country = c;
}

/** „CUI” și „Nr. Reg. Com.” în România; codul fiscal în rest, fără verificare. */
export const legal = () => legalLabels(country);

/** Țara firmei, pentru zilele libere (zile lucrătoare la livrare, Ticket 08 P13). */
export const marketCountry = (): string => country;
